// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/Users/Moniet97/Dropbox/Programming/Web_Design/moniet.github.io/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/Users/Moniet97/Dropbox/Programming/Web_Design/moniet.github.io/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

